module.exports = __webpack_public_path__ + "img/database.8c25ab9d.svg";